<template>
  <div class="equity">
    <h1>Equity for {{ headerName }}</h1>

    <div v-if="$store.state.settings_established && $store.state.expose_payments && equity.equity_remaining > 0">
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <b-button type="is-primary"
                    icon-left="dollar-sign"
                    @click="makePaymentInit()">
            Make a Payment WTF
          </b-button>
        </div>
      </div>
      <b-modal has-modal-card
               :active.sync="makePaymentShowDialog">
        <div class="modal-card">

          <header class="modal-card-head">
            <p class="modal-card-title">Make Equity Payment</p>
          </header>

          <section class="modal-card-body">

            <b-field label="Your Total Equity">
              <span>{{ equity.equity_total }}</span>
            </b-field>

            <b-field label="Remaining Balance">
              <span>{{ equity.equity_remaining_display }}</span>
            </b-field>

            <b-field label="Payment Amount">
              <div class="level-left">
                <div class="level-item">$</div>
                <div class="level-item">
                  <b-input v-model="makePaymentAmount"
                           type="number" step="0.01"
                           min="0.01" :max="equity.equity_remaining">
                  </b-input>
                </div>
              </div>
            </b-field>

          </section>

          <footer class="modal-card-foot">
            <b-button type="is-primary"
                      icon-left="dollar-sign"
                      @click="makePaymentSubmit()"
                      :disabled="makePaymentSubmitDisabled">
              {{ makePaymentSubmitting ? "Working, please wait..." : "Make this payment" }}
            </b-button>
            <b-button @click="makePaymentShowDialog = false">
              Cancel
            </b-button>
          </footer>
        </div>
      </b-modal>
    </div>

    <b-table :data="tableData">
      <b-table-column field="description"
                      v-slot="props">
        {{ props.row.description }}
      </b-table-column>
      <!-- TODO: note that this column header is empty via "simple" method -->
      <b-table-column field="value"
                      label=" "
                      numeric
                      v-slot="props">
        {{ props.row.value }}
      </b-table-column>
    </b-table>

    <br />

    <p class="is-italic">
       * Last Payment Date is when we last received an equity payment of any
       amount toward your equity account.
    </p>

    <br />

    <p class="is-italic">
       ** Last Investment Date is when we last received a total of $25 in
       payments toward your account.
    </p>

    <br />

    <p class="is-italic">
       *** Next Investment Due is the date by which you must have made your
       next investment, else lose your member privileges.
    </p>

  </div>
</template>

<script>
export default {
    name: 'Equity',
    data() {
        return {
            inited: false,
            equity: {},
            tableData: [],
            makePaymentShowDialog: false,
            makePaymentAmount: 25,
            makePaymentSubmitting: false,
        }
    },
    computed: {
        headerName: function() {
            if (! this.$store.state.user.uuid) {
                return ""
            }
            let name = this.$store.state.user.display_name
            if (this.equity.customer_number) {
                return name + " #" + this.equity.customer_number
            }
            return name
        },
        makePaymentSubmitDisabled() {
            if (this.makePaymentSubmitting) {
                return true
            }
            if (this.makePaymentAmount < 0.01) {
                return true
            }
            if (this.makePaymentAmount > this.equity.equity_remaining) {
                return true
            }
            return false
        },
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },

    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // is someone logged in?
            if (this.$store.state.user.uuid) {
                // go ahead and fetch data if it's a member
                if (this.$store.state.user.member) {
                    this.fetchData()
                } else { // send non-members back to "home" page
                    this.$router.push('/benefits')
                }
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/equity').then(response => {
                if (response.data.error) {
                    // TODO: should be smarter than just knee-jerk redirect?
                    this.$router.push('/benefits')
                } else {
                    this.equity = response.data
                    this.tableData = [
                        {description: "Total Equity", value: this.equity.equity_total},
                        {description: "Remaining Balance", value: this.equity.equity_remaining_display},
                        {description: "Last Payment Date *", value: this.equity.last_payment_date},
                        {description: "Last Investment Date **", value: this.equity.last_investment_date},
                        {description: "Next Investment Date ***", value: this.equity.next_investment_date},
                    ]
                }
            }, response => {
                // TODO: should be smarter than just knee-jerk redirect?
                this.$router.push('/benefits')
            })
        },

        makePaymentInit() {
            if (this.equity.equity_remaining > 25) {
                this.makePaymentAmount = 25
            } else {
                this.makePaymentAmount = this.equity.equity_remaining
            }
            this.makePaymentShowDialog = true
        },

        makePaymentSubmit() {
            this.makePaymentSubmitting = true

            let params = {
                'amount': this.makePaymentAmount,
            }

            this.$http.post('/api/my/equity/make-payment', params).then(response => {
                if (response.data.ok) {
                    location.href = response.data.stripe_session_url
                } else {
                    this.$buefy.toast.open({
                        message: `Failed to make payment:  ${response.data.error || 'unknown error'}`,
                        type: 'is-warning',
                        duration: 4000, // 4 seconds
                    })
                    this.makePaymentSubmitting = false
                }

            }, response => {
                this.$buefy.toast.open({
                    message: "Failed to make payment:  unknown error",
                    type: 'is-warning',
                    duration: 4000, // 4 seconds
                })
                this.makePaymentSubmitting = false
            })
        },
    },
}
</script>
